module.exports = __webpack_public_path__ + "components/country-flag/static/aw-9b749d66e4d1b982537dafff928950bf.svg";